import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { accentColors, otherColors, secondaryColors } from '@tryhackme/thm-ui-components';
import styled, { css } from 'styled-components';

export const StyledWrapper = styled.div<{ roomCode: string; $isWide: boolean }>(({ $isWide }) =>
  css({
    display: 'flex',
    margin: `3rem ${$isWide ? '3rem' : '1.8rem'} 0`,
    flexDirection: 'column',
    padding: `2.4rem ${$isWide ? '3rem' : '1.8rem'}`,
    background: 'linear-gradient(179.2deg, #223654 72.84%, #182337 145.61%, #151C2B 188.82%)',
    color: secondaryColors.grey[100],
    borderRadius: '5px',
    gap: '1.8rem',
  }),
);

export const StyledTitle = styled.h3`
  display: inline;
  margin-bottom: 0;
  margin-right: 0.6rem;
  color: ${secondaryColors.grey[100]} !important;
`;

export const StyledBody = styled.div`
  display: flex;
  gap: 3rem;
  margin-top: 0.6rem;
`;

export const StyledSubtitle = styled.div`
  font-size: 1.6rem;
  line-height: 2rem;
`;

export const StyledVirtualMachinesWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 1.6rem;
  width: 100%;
`;

export const StyledContentButtonWrapper = styled.div`
  flex-grow: 1;
  && button {
    width: 100%;
    margin-bottom: 0;
  }
  && button:hover:not(:disabled) {
    color: ${({ theme }) => theme.colors.white};
    transition: 0.2s ease-in-out;
  }
`;

export const StyledImage = styled.img<{ $isWide: boolean }>`
  display: ${({ $isWide }) => ($isWide ? 'inline-block' : 'none')};
`;

export const StyledCircleCheckIcon = styled(FontAwesomeIcon)`
  width: 1.8rem;
  height: 1.8rem;
  color: ${({ theme }) => theme.colors.primary.main};
`;

export const StyledWarningIcon = styled(FontAwesomeIcon)`
  color: ${accentColors.warning.dark};
  border: none;
  height: 2rem;
  width: 2rem;
`;

export const StyledStaticToast = styled.div`
  align-items: start;
  justify-content: start;
  display: grid;
  grid-template-columns: repeat(2, auto);
  background: ${otherColors.orange2[10]};
  gap: 1.5rem;
  border: 1px solid ${accentColors.warning.dark};
  padding: 1.6rem;
  border-radius: ${({ theme }) => theme.radius.small};
`;
